import "react-app-polyfill/stable";

import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";

import reportWebVitals from "./utils/reportWebVitals";
import { default as LeapApp } from "./apps/leap/App";
import { default as CircularEconomyApp } from "./apps/circulareconomy/App";
import { default as ThemeApp } from "./apps/theme/App";

import "./mocks";
import { SlimEpaHeader } from "./layouts/SlimEpaHeader";
import { SlimEpaFooter } from "./layouts/SlimEpaFooter";

// if using "/docs" in the pathname, don't use React Router, and serve the server response normally
if (process.env.REACT_APP_NAME === "leap") {
  if (window.location.pathname !== "/docs") {
    ReactDOM.render(
      <BrowserRouter>
        <SlimEpaHeader />
        <LeapApp />
        <SlimEpaFooter />
      </BrowserRouter>,
      document.getElementById("root")
    );
  }
} else if (process.env.REACT_APP_NAME === "circulareconomy") {
  if (window.location.pathname !== "/docs") {
    ReactDOM.render(
      <BrowserRouter>
        <SlimEpaHeader />
        <CircularEconomyApp />
        <SlimEpaFooter />
      </BrowserRouter>,
      document.getElementById("root")
    );
  }
} else if (process.env.REACT_APP_NAME === "theme") {
  if (window.location.pathname !== "/docs") {
    ReactDOM.render(
      <BrowserRouter>
        <SlimEpaHeader />
        <ThemeApp />
        <SlimEpaFooter />
      </BrowserRouter>,
      document.getElementById("root")
    );
  }
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
